import { render, staticRenderFns } from "./CommCdTable.vue?vue&type=template&id=07acd80c&"
import script from "./CommCdTable.vue?vue&type=script&lang=js&"
export * from "./CommCdTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports